import { useDebouncedValue } from "./useDebouncedValue";
import { containsLinks } from "../lib/url";

export { containsLinks };

/**
 * Debounced check for links or email addresses in user-typed prose.
 * Returns true when the debounced value contains a URL or email. Use to gate form submission and show inline errors.
 */
export function useContainsLinks(value: string, debounceMs = 400): boolean {
  const debounced = useDebouncedValue(value, debounceMs);
  return containsLinks(debounced);
}
